import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { DataObjectDescriptionVersionUrl } from '../../query/DataObjectDescriptionVersionUrl';

type ValidateDeadlinesQueryParams = {
  descriptionVersionId: number;
  validationRuleId: number;
};

const validateValidationRules = ({
  descriptionVersionId,
  validationRuleId,
}: ValidateDeadlinesQueryParams) =>
  apiClient
    .post<void>(
      expand(DataObjectDescriptionVersionUrl.validateValidationRules, {
        id: descriptionVersionId,
      }),
      { validationRuleId },
    )
    .then((response) => response.data);

export const useValidateValidationRules = createApiMutationHook(
  ['validate-validation-rules'],
  validateValidationRules,
);
